export const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR'
};
